import React, { useState, useEffect } from "react";

import { useContextProvider } from "../ContextProvider";
import { Box, Typography, Grid, MenuItem, Menu, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
// import { ReactComponent as LeftIcon } from "@deere/ux.brand-foundations/icons/chevron_left.svg";
// import { ReactComponent as RightIcon } from "@deere/ux.brand-foundations/icons/chevron_right.svg";
// import { ReactComponent as AddIcon } from "@deere/ux.brand-foundations/icons/add.svg";
// import { ReactComponent as SearchIcon } from "@deere/ux.brand-foundations/icons/search.svg";
import { MENU_EDI_TYPE, MENU_GS, MENU_ISA } from "../utils/constants";
import axios from "axios";
import { useOktaAuth } from "@okta/okta-react";
import CircularProgress from "@mui/material/CircularProgress";
import "./CategoriesMenu.css";
let cancelIsaToken;
let cancelGsToken;

export const EDITypeMenu = () => {
  const {
    ediTypeMenuVisible,
    isEdiTypeMenuVisible,
    setEdiType,
    ediType,
    searchValue,
    setSearchValue,
  } = useContextProvider();
  const onClick = () => {
    isEdiTypeMenuVisible(false);
  };

  const updateEdiType = (type, name) => {
    const element = { type: "EDI_Type", code: type, name: name };

    const tempSearchValue = searchValue.filter(
      (element) => element.type !== "EDI_Type"
    );

    setSearchValue([...tempSearchValue, element]);
    isEdiTypeMenuVisible(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <MenuItem
        onClick={(event) => updateEdiType("TRADITIONAL", "Traditional")}
      >
        Traditional
      </MenuItem>
      <MenuItem onClick={(event) => updateEdiType("WEB", "Web EDI")}>
        Web
      </MenuItem>
      <MenuItem onClick={(event) => updateEdiType("MULTIPLE", "Multiple")}>
        Multiple
      </MenuItem>
    </>
  );
};

export const ISAMenu = ({ headerTitle }) => {
 
  const { oktaAuth } = useOktaAuth();
  const token = oktaAuth.getAccessToken();

  const { isIsaMenuVisible, searchValue, setSearchValue, categoriesMenuRef } =
    useContextProvider();
  const [isa, setIsa] = useState([]);
  const [open, setOpen] = useState(false);
  const [isaToSearch, setIsaToSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const loading = open && isa.length === 0;
  console.log(open)

  const onClick = () => {
    isIsaMenuVisible(true);
  };

  useEffect(() => {
    const fetchIsaList = async () => {
      await axios
        .get(
          process.env.REACT_APP_EDI_SETUP_DETAILS_BASE_URL +
            "/api/tpload/isa/list?queryString=" +
            isaToSearch,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
            cancelToken: cancelIsaToken.token,
          }
        )
        .then((response) => {
          setIsa(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    if (isaToSearch.trim().length >= 2) {
      if (typeof cancelIsaToken !== typeof undefined) {
        cancelIsaToken.cancel("Operation canceled due to new request.");
      }
      cancelIsaToken = axios.CancelToken.source();

      fetchIsaList().then(() => {});
    } else {
      setIsa([]);
    }
  }, [isaToSearch]);

  const updateIsa = (isa) => {
    const tempSearchValue = searchValue.filter(
      (element) => element.type === "isa" && element.code === isa.value
    );
    if (tempSearchValue.length == 0) {
      const element = { type: "isa", code: isa.value, name: isa.label };
      setSearchValue([...searchValue, element]);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>


  <Box ml={4} mr={4}>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Autocomplete
          options={isa}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          loading={loading}
          fullWidth
          onChange={(event, newValue, reason) => {
            if (reason === "selectOption") {
              updateIsa(newValue);
              isIsaMenuVisible(false);
              categoriesMenuRef.current.click();
            }
          }}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          onInputChange={(event, newValue, reason) => {
            if (reason === "clear") setIsa([]);
            if (reason === "input") setIsaToSearch(newValue);
          }}
          onKeyDown={(event) => event.stopPropagation()}
          renderInput={(params) => (
            <TextField
              {...params}
              label="ISA"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <fuel-icon name="search" />
                    {params.InputProps.startAdornment}
                  </>
                ),
                endAdornment: (
                  <>
                    {loading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </Grid>
    </Grid>
    <Typography size="sm" component="p" gutterBottom>
      Please enter 2 or more characters
    </Typography>
  </Box>
</>

  );
};

export const GSMenu = ({ headerTitle }) => {
  const { oktaAuth } = useOktaAuth();
  const token = oktaAuth.getAccessToken();

  const { isGsMenuVisible, searchValue, setSearchValue, categoriesMenuRef } =
    useContextProvider();
  const [gs, setGs] = useState([]);
  const [open, setOpen] = useState(false);
  const [gsToSearch, setGsToSearch] = useState("");

  const loading = open && gs.length === 0;

  const onClick = () => {
    isGsMenuVisible(false);
  };

  useEffect(() => {
    const fetchGsList = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_EDI_SETUP_DETAILS_BASE_URL}/api/tpload/gs/list?queryString=${gsToSearch}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            cancelToken: cancelGsToken.token,
          }
        );
        setGs(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    if (gsToSearch.trim().length >= 2) {
      if (typeof cancelGsToken !== typeof undefined) {
        cancelGsToken.cancel("Operation canceled due to new request.");
      }
      cancelGsToken = axios.CancelToken.source();
      fetchGsList();
    } else {
      setGs([]);
    }
  }, [gsToSearch]);

  const updateGs = (gs) => {
    const tempSearchValue = searchValue.filter(
      (element) => element.type === "gs" && element.code === gs.gs
    );
    if (tempSearchValue.length === 0) {
      const element = { type: "gs", code: gs.gs, name: gs.gs };
      setSearchValue([...searchValue, element]);
    }
  };

  return (
    <>
      <MenuItem onClick={onClick}>
        <Box display="inline-flex" mr={2}>
          <fuel-icon name="keyboard_arrow_left" />
        </Box>
        <Typography fontWeight="bold">{headerTitle}</Typography>
      </MenuItem>

      <Box ml={4} mr={4}>
        <Grid container spacing={3}>
          <Grid item size={12}>
            <Autocomplete
              options={gs}
              getOptionLabel={(option) => option.gs}
              isOptionEqualToValue={(option, value) => option.gs === value.gs}
              loading={loading}
              fullWidth
              onChange={(event, newValue, reason) => {
                if (reason === "selectOption") {
                  updateGs(newValue);
                  isGsMenuVisible(false);
                  categoriesMenuRef.current.click();
                }
              }}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              onInputChange={(event, newValue, reason) => {
                if (reason === "clear") setGs([]);
                if (reason === "input") setGsToSearch(newValue);
              }}
              onKeyDown={(event) => event.stopPropagation()}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="GS"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <fuel-icon name="search" />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                    endAdornment: (
                      <>
                        {loading ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Typography size="sm" component="p" gutterBottom>
          Please enter 2 or more characters
        </Typography>
      </Box>
    </>
  );
};


export const CategoriesMenu = ({ visible }) => {
  const { isEdiTypeMenuVisible, isIsaMenuVisible, isGsMenuVisible } =
    useContextProvider();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClick = (menu) => {
    switch (menu) {
      case MENU_EDI_TYPE.menu_id:
        isEdiTypeMenuVisible(true);
        break;
      case MENU_ISA.menu_id:
        isIsaMenuVisible(true);
        break;
      case MENU_GS.menu_id:
        isGsMenuVisible(true);
        break;
    }
  };

  return (
    <Menu
      MenuListProps={{
        "aria-labelledby": "dropdown-button",
      }}
      anchorEl={anchorEl}
      className={"Dropdown-menu"}
      id={"dropdown-menu"}
      onClose={handleClose}
      open={open}
      style={{ minWidth: "300px" }}
    >
      <MenuItem
        disableClose={true}
        onClick={(event) => onClick(MENU_EDI_TYPE.menu_id)}
        focusVisibleClassName={"Mui-disableFocusVisible"}
      >
        {MENU_EDI_TYPE.menu_label}
        <Grid
          container
          item
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <fuel-icon name={"keyboard_arrow_right"} />
        </Grid>
      </MenuItem>
      <MenuItem
        disableClose={true}
        onClick={(event) => onClick(MENU_ISA.menu_id)}
        focusVisibleClassName={"Mui-disableFocusVisible"}
      >
        {MENU_ISA.menu_label}
        <Grid
          container
          item
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <fuel-icon name={"keyboard_arrow_right"} />
        </Grid>
      </MenuItem>
      <MenuItem
        disableClose={true}
        onClick={(event) => onClick(MENU_GS.menu_id)}
        focusVisibleClassName={"Mui-disableFocusVisible"}
      >
        {MENU_GS.menu_label}
        <Grid
          container
          item
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <fuel-icon name={"keyboard_arrow_right"} />
        </Grid>
      </MenuItem>
    </Menu>
  );
};

export const MainCategoriesMenu = () => {
  const {
    setSearchValue,
    searchValue,
    categoriesMenuRef,
  } = useContextProvider();

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuType, setMenuType] = useState("main"); // 'main', 'edi', 'isa', 'gs'
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuType("main");
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuType("main");
  };

  const handleBack = () => {
    setMenuType("main");
  };

  const handleSelect = (type, code, name) => {
    const element = { type, code, name };
    const filtered = searchValue.filter((el) => el.type !== type);
    setSearchValue([...filtered, element]);
    handleClose();
  };

  const renderMenuItems = () => {
    switch (menuType) {
      case "edi":
        return (
          <>
            <MenuItem onClick={handleBack}>
              <Box display="inline-flex" mr={2}>
                <fuel-icon name="keyboard_arrow_left" />
              </Box>
              <Typography fontWeight="bold">EDI Type</Typography>
            </MenuItem>
            <EDITypeMenu headerTitle={MENU_EDI_TYPE.menu_label} />
          </>
        );
case "isa":
  return (
    <>
      <MenuItem onClick={handleBack}>
        <Box display="inline-flex" mr={2}>
          <fuel-icon name="keyboard_arrow_left" />
        </Box>
        <Typography fontWeight="bold">{MENU_ISA.menu_label}</Typography>
      </MenuItem>
      <ISAMenu headerTitle={MENU_ISA.menu_label} />
    </>
  );

      case "gs":
        return (
          <>
            <MenuItem onClick={handleBack}>
              <Box display="inline-flex" mr={2}>
                <fuel-icon name="keyboard_arrow_left" />
              </Box>
              <Typography fontWeight="bold">{MENU_GS.menu_label}</Typography>
            </MenuItem>
            <MenuItem onClick={() => handleSelect("gs", "GS001", "GS Example")}>
              GS Example
            </MenuItem>
            <GSMenu headerTitle={MENU_GS.menu_label} />
          </>
        );
      default:
        return (
          <>
            <MenuItem onClick={() => setMenuType("edi")}>
              {MENU_EDI_TYPE.menu_label}
              <Grid container justifyContent="flex-end" alignItems="center">
                <fuel-icon name="keyboard_arrow_right" />
              </Grid>
            </MenuItem>
            <MenuItem onClick={() => setMenuType("isa")}>
              {MENU_ISA.menu_label}
              <Grid container justifyContent="flex-end" alignItems="center">
                <fuel-icon name="keyboard_arrow_right" />
              </Grid>
            </MenuItem>
            <MenuItem onClick={() => setMenuType("gs")}>
              {MENU_GS.menu_label}
              <Grid container justifyContent="flex-end" alignItems="center">
                <fuel-icon name="keyboard_arrow_right" />
              </Grid>
            </MenuItem>
          </>
        );
    }
  };

  return (
    <>
      <Button
        style={{ 
                    backgroundColor: "white",
                   }}
        ref={categoriesMenuRef}
        focusVisibleClassName="Mui-disableFocusVisible"
        onClick={handleMenuOpen}
        id="categories-button"
        aria-haspopup="true"
        aria-controls="categories-menu"
        aria-expanded={open ? "true" : undefined}
      >
        Add by other categories
      </Button>
      <Menu
        id="categories-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "categories-button",
            role: "listbox",
          },
        }}
        sx={{ minWidth: 300 }}
      >
        {renderMenuItems()}
      </Menu>
    </>
  );
};

